import { Box } from "@mui/material";
import { Relationship, YesOrNoFlug } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const splitTextAtPeriods = (text: string, rule: string): string[] => {
  const sentences = text.split(rule);
  return sentences;
};

const stepper = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLR411120_01,
  },
  {
    contractorName: "退職者名",
    keyword: "retirementStaffName",
    type: "contractorAndNumber",
    showLine: false,
  },
  {
    title: "続柄",
    keyword: "demanderRelationship",
    requiredIcon: true,
    type: "radio",
    radioPropsList: TkGetCodeList(Relationship),
  },
  {
    title: "続柄(その他入力欄)",
    keyword: "demanderRelationshipOthers",
    showLine: false,
  },
  {
    title: "退職者からの生計維持の有無",
    keyword: "livelihoodFromRetireeFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "あなたと同順位の請求権保持者の有無",
    keyword: "demanderFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    keyword: "text1",
    type: "lineTitle",
    lineTitle: (
      <>
        {splitTextAtPeriods(labelids.labelid.LBLR411120_02, "\\n").map(
          (item, index) => {
            return (
              <Box key={index} className="tkInfoText">
                {item}
              </Box>
            );
          }
        )}
      </>
    ),
  },
  {
    keyword: "text2",
    type: "lineTitle",
    lineTitle: (
      <>
        以下に、遺族請求時の必要な書類の一覧を記載します。
        <br />
        退職手当金の請求に必要な書類ですので、ご準備ください。
      </>
    ),
  },
  {
    keyword: "textDocument",
    type: "lineTitle",
    lineTitle: <></>,
  },
];

const schema: any = {
  demanderRelationship: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  demanderRelationshipOthers: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 60,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "60"),
    },
  },
};

export { stepper, fakeTableList, schema };
